// animationMixin.js
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      toggleTransition: false,

    };
  },
  computed: {
    ...mapGetters(["getRouteData"]),
  },
  methods: {
    changeTransitionCondition() {
      this.toggleTransition = true;
    },
  },
  watch: {
    getRouteData() {
      //when the route wants to change activate the leave active animation
      this.changeTransitionCondition();
    },
  },
};
